// extracted by mini-css-extract-plugin
module.exports = {"avatarImg":"form_avatarImg_2vtt6","clearButtonContainer":"form_clearButtonContainer_1xDDl"};